import 'bootstrap-tagsinput/src/bootstrap-tagsinput'

document.addEventListener('DOMContentLoaded', () => {
  $('input.tagsinput').tagsinput('items')
})
